import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes } from "react-router-dom";
import AppRoute from './config/app-route.jsx';

// bootstrap
import 'bootstrap';

// css
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.css';
import './scss/react.scss';
import './assets/css/property-manager.css';

console.log(`Environment: '${process.env.NODE_ENV}'`);
const container = document.getElementById('root');
const root = createRoot(container);

const App = () => useRoutes(AppRoute());

root.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>
);
